// extracted by mini-css-extract-plugin
export default {"file":"styles_file__DCZUb","images":"styles_images__4okTS","buttons":"styles_buttons__QewP0"};